import Api from '@/api/api.js'

export default {

    /**
     * Liste des inventaires
     */
    inventaires () {
        const promise = Api().get('/inventaires')
        return promise.then((response) => response.data)
    },


    /**
     * Recuperer  un inventaire
     */
    getInventaire (id) {
        const promise = Api().get('/inventaire/'+id)
        return promise.then((response) => response.data)
    },

    /**
     * Enregistrer un inventaire
     */
     saveInventaire (data) {
        const promise = Api().post('/inventaire', data)
        return promise.then((response) => response.data)
    },



}